<template lang="pug">
    .sv-select-input-list
        .sv-select-input-list__container(
            v-for="(value, index) in valuesWithEmpty"
            :key="index"
        )
            SvInput.sv-select-input-list__select(
                color="graylight"
                :value="value[inputs[0]]"
                :withIcon="false"
                @input="(v) => changeValueFirst(v, index)"
                placeholder="Например: 20"
            )

            SvInput.sv-select-input-list__input(
                color="graylight"
                :value="value[inputs[1]]"
                :withIcon="false"
                :class="{ 'sv-select-input-list--with-remove': value[inputs[0]] || value[inputs[1]] }"
                @input="(v) => changeValueInput(v, index)"
                placeholder="Например: Месяцев работы"
            )

            SvButton.sv-select-input-list__remove(
                v-if="value[inputs[0]] || value[inputs[1]]"
                icon
                :prependIcon=`{
                icon: 'trash',
                width: 20,
                height: 20,
                default: '#B7BAC6',
                hover: '#1993EB'
            }`
                view="primary-icon"
                @click="remove(index)"
            )
</template>

<script>
import SvSelect from '@/components/uikit/SvSelect.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvInput from '@/components/uikit/SvInput.vue';

export default {
    name: 'SvMultipleInputs',

    data() {
        return {
            latitude: '',
            longitude: '',
            coordinatesString: ''
        }
    },

    components: {
        SvSelect,
        SvButton,
        SvInput,
    },

    model: {
        prop: 'values',
        event: 'change',
    },

    props: {
        // Список всех значений
        values: {
            type: Array,
            required: true,
        },

        inputs: {
            type: Array,
            default: [],
        },
    },

    computed: {
        valuesWithEmpty() {
            return [...this.values, {[this.inputs[0]]: '', [this.inputs[1]]: ''}];
        },
    },

    methods: {

        changeCoordinatesInput(value, index) {
            const copyValues = [...this.values];
            const currentValue = copyValues[index];
            copyValues.splice(index, 1, {
                ...currentValue,
                coordinatesString: value,
            });
            this.$emit('change', copyValues);
        },

        changeCoordinatesBlur(value, index) {
            const copyValues = [...this.values];
            const currentValue = copyValues[index];
            const coordinates = value.split(', ');

            copyValues.splice(index, 1, {
                ...currentValue,
                latitude: coordinates[0] || '',
                longitude: coordinates[1] || ''
            });
            this.$emit('change', copyValues);
        },


        changeValueInput(value, index) {
            const copyValues = [...this.values];
            const currentValue = copyValues[index];
            copyValues.splice(index, 1, {
                ...currentValue,
                [this.inputs[1]]: value,
            });
            this.$emit('change', copyValues);
        },

        changeValueFirst(value, index) {
            const copyValues = [...this.values];
            const currentValue = copyValues[index];
            copyValues.splice(index, 1, {
                ...currentValue,
                [this.inputs[0]]: value,
            });
            this.$emit('change', copyValues);
        },

        remove(index) {
            const temp = this.values.slice();
            temp.splice(index, 1);
            this.$emit('change', temp);
        },
    },
};
</script>

<style lang="scss" scoped>
.sv-select-input-list__container {
    margin-bottom: 15px;

    &:last-child {
        margin-bottom: 0;
    }
}

.sv-select-input-list {
    &--with-remove {
        // margin-bottom: 15px;
    }

    &__container {
        display: flex;
    }

    &__select {
        width: 160px;
        margin-right: 10px;
    }

    &__input {
        width: calc(100% - 50px - 170px);
        margin-right: 10px;
    }
}
</style>
